import React from 'react'

import { AuthProvider, useAuth } from './hooks/auth'
import { Container, ContentContainer } from '@shared/components/Layout'
import { QueryProvider } from './hooks/query'
import { BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { ToastProvider } from './hooks/toast'
import { BalanceProvider } from '@shared/hooks/balance'

import BottomTabs from './layouts/Partials/BottomTabs'
import GlobalStyle from './styles/global'
import Navigation from '@shared/layouts/Partials/Navigation'
import Routes from './routes'
import themes from '@config/themes'
import { ConfigsProvider } from '@shared/hooks/configs'

const AppLayout = () => {
  const { user: isSigned, module: hasModule, module } = useAuth()

  const themeModule = themes[module?.name] || {}

  return (
    <ThemeProvider theme={{ ...themes.default, ...themeModule }}>
      <GlobalStyle />
      <ToastProvider>
        <ConfigsProvider>
          <BalanceProvider>
          <Container>
          <Router>
            <QueryProvider>
              {(isSigned, hasModule) && <Navigation module={module} />}
              <ContentContainer>
                <Routes />
              </ContentContainer>
              {(isSigned, hasModule) && <BottomTabs module={module} />}
            </QueryProvider>
            </Router>
          </Container>
        </BalanceProvider>
        </ConfigsProvider>
      </ToastProvider>
    </ThemeProvider>
  )
}

const App = () => {
  return (
    <AuthProvider>
      <AppLayout />
    </AuthProvider>
  )
}

export default App
